import { forwardRef } from "react";
import type { InputHTMLAttributes, TextareaHTMLAttributes } from "react";
import { Icon } from "../icons";
import type { IconName } from "../icons";
import { Button } from "./Button";

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  icon?: IconName | null;
  onClear?: (() => void) | null;
  clearLabel?: string;
  invalid?: boolean;
  mono?: boolean;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input({ icon = null, onClear = null, clearLabel = "", invalid = false, mono = false, className, value, ...rest }, ref) {
  const hasValue = value !== undefined && value !== null && String(value).length > 0;

  return (
    <span className={["fxmap-input-wrap", icon !== null ? "fxmap-input-with-icon" : "", onClear !== null ? "fxmap-input-clearable" : "", className ?? ""].filter(Boolean).join(" ")}>
      {icon !== null ? <Icon name={icon} className="fxmap-input-icon" /> : null}
      <input {...rest} ref={ref} value={value} className={["fxmap-input", mono ? "fxmap-mono" : "", invalid ? "fxmap-input-invalid" : ""].filter(Boolean).join(" ")} aria-invalid={invalid || undefined} />
      {onClear !== null && hasValue ? <Button kind="icon" size="sm" icon="close" label={clearLabel} className="fxmap-input-clear" onClick={onClear} tabIndex={-1} /> : null}
    </span>
  );
});

export type TextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & { invalid?: boolean; mono?: boolean };

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea({ invalid = false, mono = false, className, ...rest }, ref) {
  return <textarea {...rest} ref={ref} className={["fxmap-input", "fxmap-textarea", mono ? "fxmap-mono" : "", invalid ? "fxmap-input-invalid" : "", className ?? ""].filter(Boolean).join(" ")} aria-invalid={invalid || undefined} />;
});
